import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Toaster } from "./components/ui/sonner";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import SchedulePage from "./pages/SchedulePage";
import UsersPage from "./pages/UsersPage";
import SectorsPage from "./pages/SectorsPage";
import FunctionsPage from "./pages/FunctionsPage";

function AppRouter() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route 
        path="/dashboard" 
        element={
          <ProtectedRoute>
            <DashboardPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/schedule" 
        element={
          <ProtectedRoute>
            <SchedulePage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/users" 
        element={
          <ProtectedRoute requireAdmin>
            <UsersPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/sectors" 
        element={
          <ProtectedRoute requireAdmin>
            <SectorsPage />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/functions" 
        element={
          <ProtectedRoute requireAdmin>
            <FunctionsPage />
          </ProtectedRoute>
        } 
      />
      <Route path="/" element={<LoginPage />} />
      <Route path="*" element={<LoginPage />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter basename={process.env.REACT_APP_BASENAME || "/"}>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
